/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Advanced_Options_ButtonInputs */

const en_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Options`)
};

const fr_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options avancees`)
};

const de_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte Optionen`)
};

const it_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni avanzate`)
};

const ru_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширенные параметры`)
};

const es_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones avanzadas`)
};

const zh_cn2_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级选项`)
};

const ja_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細オプション`)
};

const hi_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन्नत विकल्प`)
};

const pt_pt2_plain_text_import_advanced_options_button = /** @type {(inputs: Plain_Text_Import_Advanced_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções avançadas`)
};

/**
* | output |
* | --- |
* | "Advanced Options" |
*
* @param {Plain_Text_Import_Advanced_Options_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_advanced_options_button = /** @type {((inputs?: Plain_Text_Import_Advanced_Options_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Advanced_Options_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_advanced_options_button(inputs)
	if (locale === "de") return de_plain_text_import_advanced_options_button(inputs)
	if (locale === "it") return it_plain_text_import_advanced_options_button(inputs)
	if (locale === "ru") return ru_plain_text_import_advanced_options_button(inputs)
	if (locale === "es") return es_plain_text_import_advanced_options_button(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_advanced_options_button(inputs)
	if (locale === "ja") return ja_plain_text_import_advanced_options_button(inputs)
	if (locale === "hi") return hi_plain_text_import_advanced_options_button(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_advanced_options_button(inputs)
	return en_plain_text_import_advanced_options_button(inputs)
});